import { createEntityAdapter } from "@ngrx/entity";
import { RoleModel, Role, Permission } from "../Model/Role.model";

export const RoleAdapter = createEntityAdapter<Role>();

export const RoleState: RoleModel = RoleAdapter.getInitialState({
        rolelist:[],
    });

// export const RoleState: Role ={
//         menu: '',
//         submenu: '',
//         permission: {
//                 create: false,
//                 read: false,
//                 update: false,
//                 delete: false,
//                 export_excel: false
//         }
// };
